import { StrictStyleOptions } from './druid/StyleOptions';
import useWebChatAPIContext from '/druid/internal/useWebChatAPIContext';

export default function useStyleOptions(): [StrictStyleOptions] {
  return [useWebChatAPIContext().styleOptions];
}
